// Define known server errors and map them to user-friendly messages
// -- serverError: the error message received from the server
// -- userFriendlyError: the key for the json translation files
// -- logServerError: whether to log the error in the console
const serverErrors = [
    {
        serverError: 'Unexpected token',
        userFriendlyError: '$common.$validation.serverError',
        logServerError: true,
    },
    {
        serverError: 'A customer with the same email address already exists in an associated website.',
        userFriendlyError: '$common.$validation.customerExists',
        logServerError: false,
    },
    // TODO: Check if this is ever returned
    {
        serverError: 'Confirm Password not same as your password',
        userFriendlyError: '$common.$validation.passwordsNotMatch',
        logServerError: false,
    },
    // TODO: Check if this is ever returned
    {
        serverError: 'Reset password token mismatch.',
        userFriendlyError: '$common.$validation.resetPasswordTokenMismatch',
        logServerError: false,
    },
    // TODO: Check if this is ever returned
    {
        serverError: 'You did not sign in correctly or your account is temporarily disabled.',
        userFriendlyError: '$common.$validation.signInError',
        logServerError: false,
    },
    {
        serverError: 'Required parameter "cart_id" is missing',
        userFriendlyError: '$common.$validation.cartIdMissing',
        logServerError: false,
    },
    {
        serverError: 'Could not find specified product.',
        userFriendlyError: '$common.$validation.kitItemNotAvailable',
        devMsg: 'This error usually occurs when a kit component is disabled in Magento.',
        logServerError: false,
    },
    {
        serverError: 'The requested qty is not available',
        userFriendlyError: '$common.$validation.maximumQuantity',
        logServerError: false,
    },
    {
        serverError: 'The requested qty exceeds the maximum qty allowed in shopping cart',
        userFriendlyError: '$common.$validation.maximumQuantity',
        logServerError: false,
    },
    {
        serverError: 'Product that you are trying to add is not available',
        userFriendlyError: '$common.$labels.outStock',
        logServerError: false,
    },
    {
        serverError: 'PayPal gateway has rejected request. A match of the Shipping Address City, State, and Postal Code failed (#10736: Shipping Address Invalid City State Postal Code).',
        userFriendlyError: '$common.$validation.invalidZipCode',
        logServerError: false,
        errorInput: 'postcode',
    },
    {
        serverError: 'Unable to place order: Some of the products are out of stock.',
        userFriendlyError: '$common.$validation.productsOutOfStock',
        logServerError: false,
    },
    {
        serverError: "The current customer isn't authorized.",
        userFriendlyError: '$common.$validation.sessionExpired',
        logServerError: false,
    },
    {
        serverError: 'Invalid login or password.',
        userFriendlyError: '$common.$validation.loginResponseError',
        logServerError: false,
    },
];
const ERROR_CUSTOMER_NOT_AUTHORIZED = "The current customer isn't authorized.";
const ERROR_CART_SESSION_EXPIRED = 'Your session has expired. Please log in again';
const ERROR_CART_NOT_ACTIVE = "The cart isn't active.";
const ERROR_CART_NOT_ACTIVE_TWO = 'The cart is not active';
const ERROR_CART_ID_NOT_FOUND = 'Could not find a cart with ID';
const ERROR_CART_CANNOT_PERFORM_OPERATIONS = 'The current user cannot perform operations on cart';
const ERROR_SHIPPING_INFORMATION_UNABLE_TO_BE_SAVED = 'The shipping information was unable to be saved';
const ERROR_INTERNAL_SERVER_ERROR = 'Internal server error';
const ERROR_CART_ITEM_NOT_FOUND = "The cart doesn't contain the item";
const ERROR_CART_ITEM_NOT_FOUND_TWO = 'Could not find cart item with id';

export { ERROR_CUSTOMER_NOT_AUTHORIZED as E, ERROR_CART_SESSION_EXPIRED as a, ERROR_CART_NOT_ACTIVE as b, ERROR_CART_NOT_ACTIVE_TWO as c, ERROR_CART_ID_NOT_FOUND as d, ERROR_CART_CANNOT_PERFORM_OPERATIONS as e, ERROR_SHIPPING_INFORMATION_UNABLE_TO_BE_SAVED as f, ERROR_INTERNAL_SERVER_ERROR as g, ERROR_CART_ITEM_NOT_FOUND as h, ERROR_CART_ITEM_NOT_FOUND_TWO as i, serverErrors as s };
//# sourceMappingURL=serverErrors-JVvpO9sB.js.map
